// extracted by mini-css-extract-plugin
module.exports = {"block":"Dialog_block__2f1HI","block_selected":"Dialog_block_selected__cGeTu","name":"Dialog_name__27hAU","tag":"Dialog_tag__1o6ny","date":"Dialog_date__33g0a"};